export var isNumber = function isNumber(val) {
  return typeof val === 'number';
};
export var isString = function isString(val) {
  return typeof val === 'string';
};
export var isUndefined = function isUndefined(val) {
  return typeof val === 'undefined';
};
export var isFunction = function isFunction(val) {
  return typeof val === 'function';
};
export var isFloat = function isFloat(val) {
  return typeof val === 'number' && val % 1 !== 0;
};
export var isInt = function isInt(val) {
  return typeof val === 'number' && val % 1 === 0;
};
export var isArray = function isArray(value) {
  return value instanceof Array;
};
export var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
export var isObject = function isObject(value) {
  return !isArray(value) && value instanceof Object;
};
export var get = function get(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultValue = arguments.length > 2 ? arguments[2] : undefined;

  try {
    if (isNumber(keys)) {
      keys = String(keys);
    }

    var result = (isString(keys) ? keys.split('.') : keys).reduce(function (res, key) {
      return res[key];
    }, obj);
    return isUndefined(result) ? defaultValue : result;
  } catch (e) {
    return defaultValue;
  }
};